module.exports = __webpack_public_path__ + "static/media/main.9ab5ea34.svg";